import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { CommonService } from 'src/app/services/common.service';
import { AuthService } from 'src/app/services/auth.service';
import {DocumentService} from '../../services/document.service'
@Component({
  selector: 'app-ca-document',
  templateUrl: './ca-document.component.html',
  styleUrls: ['./ca-document.component.scss']
})
export class CaDocumentComponent implements OnInit {
  uploadedDocs = []
  requiredDocs=[]
  files:any={}
  selectedType=null
  canUpload = true
  constructor(public documentService:DocumentService,public messageService:MessageService,public common:CommonService,public auth:AuthService) { }

  ngOnInit(): void {
    this.getDocuments()
  }

  getDocuments(){
    this.common.showLoader()
    this.documentService.getDocumentList().subscribe((res:any)=>{
      //console.log(res)
      this.uploadedDocs = res.user_documents
      this.requiredDocs=res.document_list
      this.common.stopLoader()
    },err=>{
      let errorKeys = Object.keys(err.error.errors); 
      errorKeys.forEach(key => { 
        //console.log(key)
        let value = err.error.errors[key][0]; 
        this.messageService.add({severity:'error', summary:value, detail:""});
        //console.log(value); 
    }); 
      //console.log(err)
      this.common.stopLoader()
    })
  }

  onDocumentFormSubmit(documentForm:NgForm){

    //console.log(documentForm.value)
    let formData = new FormData()
    this.selectedType.requiredFiles.forEach(element => {
      formData.append(element, this.files[element], this.files[element].name)
      //console.log(formData.get(element))
    });
    formData.append("document_type_id",documentForm.value.document_type_id)
    formData.append("sender_id_number",documentForm.value.sender_id_number)

    this.common.showLoader()
    this.documentService.uploadDoc(formData).subscribe((res:any)=>{
      //console.log(res)
      if(res.result){
        // this.messageService.add({severity:'success', summary:'Successful', detail:res.message});
        this.getDocuments()
        documentForm.resetForm()
        this.selectedType=null
      }
      else{
        this.messageService.add({severity:'error', summary:res.message, detail:""});
      }
      this.common.stopLoader()
    },err=>{
      //console.log(err)
      this.common.stopLoader()
    })
  }

  onFileChanged(name,event){
    /* //console.log(event.srcElement.name)
    //console.log(event.target.files[0])
    this.selected_kyc_1=event.target.files[0] */
    this.files[name]=event.target.files.item(0)
      this.canUpload = true
      this.selectedType.requiredFiles.forEach(element => {
          if(this.files[element].size > 110000000) {
              this.canUpload = false
          }
      });
  }

  onTypeChange(id){
    this.files={}
    this.selectedType=this.requiredDocs.find(element=>{
      //console.log(element.id,id)
      return element.id==id
    })
    //console.log(this.selectedType)
  }

  cancelUpload(form:NgForm){
    form.reset({document_type_id:""})
    this.selectedType=null
  }
  






}
